import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import Cookies from "js-cookie";
import subkonMangkirService from "../../services/subkonMangkirService";

export const initialState = {
    loading_subkon_mangkir: false,
    data_subkon_mangkir: [],
    data_import: [],
    showMessage:false,
    message:'',
}

export const getDataSubkonMangkir = createAsyncThunk('subkon_mangkir/data',async (data, { rejectWithValue }) => {
    try {
        const response = await subkonMangkirService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        // handle error silently
    }
})

export const getaDataImport = createAsyncThunk('subkon_mangkir/dataimport',async (data, { rejectWithValue }) => {
    try {
        const response = await subkonMangkirService.data_import(Cookies.get(AUTH_TOKEN), data)
        return response
    } catch (err) {}
})

export const emptyDataImport = createAsyncThunk('subkon_mangkir/emptyimport',async (data, { rejectWithValue }) => {
    try {
        const response = await subkonMangkirService.empty_import(Cookies.get(AUTH_TOKEN), data)
        return response
    } catch (err) {}
})

export const saveDataImport = createAsyncThunk('subkon_mangkir/saveimport',async (data, { rejectWithValue }) => {
    try {
        const response = await subkonMangkirService.save_import(Cookies.get(AUTH_TOKEN), data)
        return response
    } catch (err) {}
})

export const subkonMangkirSlice = createSlice({
    name: 'subkon_mangkir',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_subkon_mangkir = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataSubkonMangkir.fulfilled, (state, action) => {
                state.loading_subkon_mangkir = false
                state.data_subkon_mangkir = action.payload??[]
            })
            .addCase(getDataSubkonMangkir.pending, (state) => {
                state.loading_subkon_mangkir = true
            })
            .addCase(getDataSubkonMangkir.rejected, (state, action) => {
                state.loading_subkon_mangkir = false
                state.data_subkon_mangkir = action.payload
            })
            .addCase(getaDataImport.fulfilled, (state, action) => {
                state.loading_subkon_mangkir = false
                state.data_import = action.payload??[]
            })
            .addCase(getaDataImport.pending, (state) => {
                state.loading_subkon_mangkir = true
            })
            .addCase(getaDataImport.rejected, (state, action) => {
                state.loading_subkon_mangkir = false
                state.data_import = action.payload
            })
    },
})

export const {
    showLoading,
} = subkonMangkirSlice.actions

export default subkonMangkirSlice.reducer
